import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { PaymentFoundationTrusteeRouter } from './payment-foundation-trustee.router';
import { reducers } from './state/payment-foundation-trustee.selectors';

@NgModule({
  imports: [
    PaymentFoundationTrusteeRouter,
    StoreModule.forFeature('paymentFoundationTrustee', reducers),
  ],
  declarations: []
})
export class PaymentFoundationTrusteeScreenModule { }